import { ReactComponent as ArrowRight } from 'assets/img/icons/chevron-right.svg';
import { ReactComponent as ArrowLeft } from 'assets/img/icons/chevron-left.svg';

const ExpandableButton = ({ green, children, isActive, onClick }) => {
  return (
    <>
      <button className={`btn-expand ${green ? 'green' : ''}`} onClick={onClick}>
        {isActive ? <ArrowLeft style={{ marginRight: 8 }} /> : <ArrowRight style={{ marginRight: 8 }} />}
        {children}
      </button>
    </>
  );
};

export default ExpandableButton;
